import Icon from '../components/Icon.vue'

Icon.register({
  ban: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM386.1 125.9C451.6 191.3 456.1 291.4 406.8 361.5L150.5 105.2C220.7 55.9 320.7 60.5 386.1 125.9zM125.9 386.1C60.4 320.7 55.9 220.6 105.2 150.5L361.5 406.8C291.3 456.1 191.3 451.5 125.9 386.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ban.js
// module id = CtZz
// module chunks = 144